import React from 'react';
import { Button, ButtonProps, Box, useTheme } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface CommonButtonProps extends ButtonProps {
  icon?: SvgIconComponent; // Optional icon to include
  label: string; // Button label
  onClick: () => void; // Click handler
}

const CommonButton: React.FC<CommonButtonProps> = ({
  icon: Icon,
  label,
  onClick,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
  
        color: '#FFF',
        background: '#F0845D',
        fontSize: '12px',
        textTransform: 'none',
        padding:1.5,
        borderRadius: '8px',
        width: '100%',
        boxShadow: 'none',
        ':hover': {
          background: '#F0845D',
          boxShadow: '1px',
        },
        ...props.sx, 
      }}
      {...props}
    >
      {Icon && <Icon />} 
      <Box /> 
      {label} 
    </Button>
  );
};

export default CommonButton;
